<template>

  <div class="down">


    <div id="pc">


    </div>

    <div id='mobile-down'>

          <div @click="download('ios')"><img src="@/img/mobile/Frame 1558@2x.png" alt=""><span>苹果下载</span></div>
          <div @click="download('android')"><img src="@/img/mobile/Frame 1559@2x.png" alt=""><span>安卓下载</span></div>

      </div>



   

  </div>


</template>

<script>
  import api from "@/api/api";
  import request from '@/api/request';
  import {
    Notify
  } from 'vant';
  import {
    Dialog
  } from 'vant';
  export default {
    components: {

    },
    data() {
      return {
       

      }
    },
    created() {


    },
    computed: {

    },
    mounted() {


    },

    destroyed() {

    },
    methods: {
           download(type) {
        if (type == 'android') {
          this.$router.push('/toDown');
        }
        if (type == 'ios') {

          window.location.href =  api.apiConfig.iosUrl
        }

        if (type == 'web') {
          window.open(api.apiConfig.iosUrl.haiouWeb, '_blank');
        }

      },
      downApp() {
        var userAgent = navigator.userAgent;
        //console.log(userAgent)
        //alert(userAgent)
        var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1; //android终端
        var isIOS = !!userAgent.match(/macintosh|mac os x/i);
        //alert(isIOS)
        //0 安卓 1 ios
        var type = 0;
        if (isIOS) {
          //window.location.href = 'https://apps.apple.com/cn/app/%E6%B5%B7%E9%B8%A5m/id6449927022'
          //window.location.href = 'itms-services://?action=download-manifest&amp;url=https://zd.oss.haiouchat.com/manifest.plist'
          window.location.href =
            'https://apps.apple.com/cn/app/%E6%B5%B7%E9%B8%A5-%E5%AE%89%E5%85%A8%E5%8A%A0%E5%AF%86%E8%81%8A%E5%A4%A9%E4%BA%A4%E5%8F%8B%E8%BD%AF%E4%BB%B6/id1584062834'


        } else {
          window.location.href = 'https://www.haiouchat.com/app/haiou.apk'
        }


      }


    }
  }

</script>

//pc端
<style scoped>
  /* 当屏幕宽度大于或等于768像素时，改为浮动布局 */
  @media (min-width: 768px) {

    #mobile-down {
      display: none;
    }




  }

</style>

//移动端
<style scoped>
  /* 当屏幕宽度小于或等于768像素时，应用以下样式 */
  @media (max-width: 768px) {
    #pc {
      display: none;
    }

   .down{
    width: 100%;

   }
   #mobile-down{
    height: 44px;
    display: flex;
    flex-flow: row;
   justify-content: space-between;
   
   margin-right: 23px;
   margin-left: 23px;
   margin-bottom: 10px;
   margin-top: 10px;
   }

#mobile-down>div>img{
  width: 24px;
height: 24px;
margin-right: 8px;
margin-left: 33px;
}
      #mobile-down>div:first-child{
            display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    align-content: center;
width: 154px;
height: 44px;
background: rgba(67,113,255,0.14);
border-radius: 4px 4px 4px 4px;

font-family: PingFang SC, PingFang SC;
font-weight: 500;
font-size: 14px;
color: #4371FF;
line-height: 28px;
text-align: left;
font-style: normal;
text-transform: none;

   }

      #mobile-down>div:last-child{
                    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    align-content: center;
width: 154px;
height: 44px;
background: rgba(51,207,57,0.14);
border-radius: 4px 4px 4px 4px;

font-family: PingFang SC, PingFang SC;
font-weight: 500;
font-size: 14px;
color: #39BD66;
line-height: 28px;
text-align: left;
font-style: normal;
text-transform: none;

   }
  }

</style>



// WEBPACK FOOTER //
// src/components/down/index.vue